import builder from '../builder';
import CashPaymentBill1 from '../../streamline-icons/bold/cash-payment-bill-1.svg';

export default builder('IconCashPaymentBill1Bold', CashPaymentBill1);
